export const STAR_RATING_MAX_STARS = 5;

export const STAR_RATING_MAX_COMMENT_LENGTH = 1000;

// Prefix of the reporting survey id: `feedback_<tracking-url>`, e.g. `feedback_thank_you_page`.
export const STAR_RATING_SURVEY_ID_PREFIX = 'feedback_';

// The tracking location is embedded verbatim in the survey id, so it has to stay a snake_case slug:
// anything else either fragments the reporting data or produces an unusable survey id.
export const STAR_RATING_TRACKING_LOCATION_PATTERN = /^[a-z0-9_]+$/;

export function isValidTrackingLocation(location: string | undefined | null): location is string {
  return typeof location === 'string' && STAR_RATING_TRACKING_LOCATION_PATTERN.test(location);
}

export type StarRatingVariant = 'rating_comment' | 'rating_only';

export interface StarRatingSurveyAnswer {
  question: string;
  answers: string[];
}

export interface StarRatingSubmissionPayload {
  rating: number;
  variant: StarRatingVariant;
  location: string;
  url: string;
  countryCode: string;
  comment?: string;
  orderReference?: string;
}

export type StarRatingSubmissionResult = { success: true } | { success: false };

export interface StarRatingFeedbackEvent {
  rating: number;
  comment_provided?: boolean;
  variant: StarRatingVariant;
  location: string;
}
